const ENABLE_BRANDING_DEVTOOLS_KEY = 'branded';
export const MOCK_DOMAIN_KEY = 'MOCKED_DOMAIN';
export const DEFAULT_MOCK_DOMAIN = 'https://merchant-v.zeal-members.com';

/**
 * This function is used to check if the branding dev tools are enabled.
 * It returns true if the branding dev tools are enabled and the current environment is in the provided list of allowed environments.
 */
export const enableDevToolsForBranding = (): boolean => {
	if (!['development', 'qa'].includes(import.meta.env.MODE)) return false;

	return localStorage.getItem(ENABLE_BRANDING_DEVTOOLS_KEY) === 'true';
};
